import React, { useRef, useState, useEffect } from "react";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from "@/components/YhFormBox/Types";
import { useVehicleModel } from "../vehicleModel";
import { YhPageHeader } from "@/components/YhPageHeader";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IVehicleDetail } from "../vehicleType";
import { getFormValidatorErrText, transOptions } from "@/utils/utils"
import { useCustomerModel } from "../../customer/baseCustomerModel"
import { useDictModel } from "../../../dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums"
import { useGlobalModel } from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { debounce } from "lodash";
export const BaseVehicleDetails = () => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale, CustomerData } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const {
        addFormVal,
        editFormVal,
        updateAddFormVal,
        updateEditFormVal,
        insertDetail,
        editDetail,
        getDetailOne,
        setAddFormVal,
        setSelectedRowKeys
    } = useVehicleModel();
    const { getTreeSelectOne, getSelectedDictOne } = useDictModel();
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    const formRef = useRef<IYhFormRef>();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);

    //编辑时， 没有缓在调用详情接口
    useEffect(() => {
        if (!Object.keys(editFormVal).length && detailsInfo.mode === "edit") {
            getDetailOne(detailsInfo.id)
        }
    }, [detailsInfo]);

    useEffect(() => {
        return () => {
            let addNavExist = findNav("13-5-2-1");
            let editNavExist = findNav("13-5-2-2");
            !addNavExist && updateAddFormVal(null);
            !editNavExist && updateEditFormVal(null);
        }
    }, [])

    //关闭当前页
    const onClose = () => {
        let { parentInfo } = detailsInfo
        if (parentInfo) {
            replaceNav(selectedNavId, parentInfo.selectedNavId);
        } else {
            replaceNav(selectedNavId, "13-5-2");
            detailsInfo.mode === "edit" ? updateEditFormVal(null) : updateAddFormVal(null);
        }
        // replaceNav(selectedNavId, "13-5-2");
        // detailsInfo.mode === "edit" ? updateEditFormVal(null) : updateAddFormVal(null);
    }

    //表单提交
    const onSubmit = async () => {
        formRef.current?.validateFields().then(res => {
            if (detailsInfo.mode === "edit") {
                editDetail({ ...res, id: detailsInfo.id } as IVehicleDetail).then(res => {
                    res && onClose()
                })
            } else {
                insertDetail(res as IVehicleDetail).then(res => {
                    if(res){
                        setSelectedRowKeys([res])
                        onClose()
                    }
                    // res && onClose()
                })
            }
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }

    //实时保留缓存
    const onChange = (changedValues: { [key: string]: any }) => {
        detailsInfo.mode === "edit" ? updateEditFormVal(changedValues) : updateAddFormVal(changedValues);
    }

    const baseFormItem: IYhFormItemsBox = {
        // title: "基础信息",
        title: Locale["Basic Info"],
        style: { padding: "18px 77px 0 0", marginBottom: "15px" },
        items: [
            {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "Customer Code",
                fieldLabel: Locale["Customer Code"],
                fieldName: "customerCode",
                disable: true
            }, {
                type: FormItemTypeEnum.Select,
                // fieldLabel: "客户名称",
                fieldLabel: Locale["Customer"],
                allowClear: true,
                showSearch: true,
                fieldName: "customerCode",
                options: transOptions(CustomerData)
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "联系人",
                fieldLabel: Locale["Contact"],
                fieldName: "contact",
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "联系电话",
                fieldLabel: Locale["Contact Number"],
                fieldName: "phone"
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "车辆编码",
                fieldLabel: Locale["Vehicle Code"],
                fieldName: "code",
                // rules: [{ required: true, message: "请选择车辆编码" }]    
            }, {
                type: FormItemTypeEnum.Select,
                // fieldLabel: "车辆类型",
                fieldLabel: Locale["Vehicle Type"],
                fieldName: "categoryCode",
                options: getSelectedDictOne(DictCodeEnmu.VEHICLE_TYPE),
                // rules: [{ required: true, message: "请选择车辆类型" }]
                rules: [{ required: true, message: Locale["This item is Required"] }]
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "车辆型号",
                fieldLabel: Locale["Vehicle Model"],
                fieldName: "model"
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "车牌号",
                fieldLabel: Locale["License Plate"],
                fieldName: "licensePlate"
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "Vin码",
                fieldLabel: Locale["VIN"],
                fieldName: "vin"
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "发动机号",
                fieldLabel: Locale["Engine No."],
                fieldName: "engineCode"
            }, {
                type: FormItemTypeEnum.Datepicker,
                // fieldLabel: "车辆出厂日期",
                fieldLabel: Locale["Delivery Time"],
                fieldName: "registerDate"
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "登记日期",
                fieldLabel: Locale["Record Time"],
                fieldName: "createTime",
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "使用性质",
                fieldLabel: Locale["Using Property"],
                fieldName: "natureCode"
            }, {
                type: FormItemTypeEnum.Input,
                // fieldLabel: "备注",
                fieldLabel: Locale["Note"],
                fieldName: "note"
            }, {
                type: FormItemTypeEnum.Switch,
                // fieldLabel: "状态",
                fieldLabel: Locale["Vehicle Status"],
                fieldName: "enable"
            }
        ]
    };
    // const priceFormItem: IYhFormItemsBox = {
    //     title: "保养信息（字段暂无）",
    //     style: { padding: "18px 77px 0 0", marginBottom: "15px" },
    //     items: [
    //         {
    //             type: FormItemTypeEnum.Input,
    //             fieldLabel: "上次保养日期",
    //             fieldName: "createTime"
    //         }, {
    //             type: FormItemTypeEnum.Input,
    //             fieldLabel: "上次保养里程",
    //             fieldName: "createTime"
    //         }, {
    //             type: FormItemTypeEnum.Input,
    //             fieldLabel: "下次保养日期",
    //             fieldName: "createTime"
    //         }, {
    //             type: FormItemTypeEnum.Input,
    //             fieldLabel: "下次保养里程",
    //             fieldName: "createTime"    
    //         }, {
    //             type: FormItemTypeEnum.Input,
    //             fieldLabel: "最新里程",
    //             fieldName: "createTime"                      
    //         }
    //     ]
    // }


    const supplierFromConfig: IYhFormBox = {
        formRef,
        labelCol: { span: 6 },
        labelAlign: "right",
        formValues: detailsInfo.mode === "edit" ? editFormVal : addFormVal,
        onChange,
        boxs: [baseFormItem]
    }

    const reset = async () => {
        formRef.current?.resetFields()
        if (detailsInfo.mode === "add") {
            setAddFormVal({})
        } else if (detailsInfo.mode === "edit") {
            getDetailOne(detailsInfo.id)
        }
        message.success("重置成功")
    }
    const action = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            // onClick={onSubmit}
            onClick={debounce(() => { onSubmit() }, 900)}
        >{Locale["Save"]}</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => reset()}
        >{Locale["Reset"]}</Button>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={onClose}
        >{Locale["Back"]}</Button>
    </>;

    return (
        <>
            <YhPageHeader title={Locale["Vehicle Details"]} />
            <YhBox title={`${detailsInfo.mode === "edit" ? Locale["Edit Vehicle"] :  Locale["Add Vehicle"]}`} action={action} style={{ paddingBottom: "0px", marginBottom: "15px" }}></YhBox>
            <YhFormBox {...supplierFromConfig} />
        </>
    )
}